const SDK_TYPES = [
	{ value: 'originalApi', label: 'Original API', code: 0 },
	{ value: 'renderingApi', label: 'Rendering API', code: 1 },
];

const PLATFORM_TYPES = [
	{ value: 'ios', label: 'iOS', code: 0 },
	{ value: 'android', label: 'Android', code: 1 },
];

const toCodeMap = (arr) => Object.fromEntries(arr.map(({ value, code }) => [value, code]));

const SDK_TYPE_CODES = toCodeMap(SDK_TYPES);
const PLATFORM_TYPE_CODES = toCodeMap(PLATFORM_TYPES);

// Default conditions by bidder code, for bidders without their own SSP implementation.
// SSPs we have implemented should instead override getDefaultStrictImpressionCountingSettings()
const DEFAULT_CONDITIONS_BY_BIDDER = {
	inmobi: [
		{ sdkType: 'renderingApi', platformType: 'ios' },
	],
};

module.exports = {
	SDK_TYPES,
	PLATFORM_TYPES,
	SDK_TYPE_CODES,
	PLATFORM_TYPE_CODES,
	DEFAULT_CONDITIONS_BY_BIDDER,
};
